var shape = {
  borderRadius: 4
};
export default shape;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/styles/shape.js
// module id = 1650
// module chunks = 121